/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import dateFormat from 'date-fns/format';
import Slider from 'react-slick';
import Link from 'components/Link';
import s from './ArticleshowInsertSchedule.scss';
// eslint-disable-next-line no-unused-vars
import slickcss from '../../../../../../node_modules/slick-carousel/slick/slick.css';

const slickResponsiveSetting = [
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1.2,
      slidesToScroll: 1,
      arrows: false,
    },
  },
  {
    breakpoint: 361,
    settings: {
      slidesToShow: 1.04,
      slidesToScroll: 1,
      arrows: false,
    },
  },
];
const slickResponsiveSettingAS = [
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 1.25,
      slidesToScroll: 1,
    },
  },
  ...slickResponsiveSetting,
];

class ArticleshowInsertSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableTimer: false,
      isShowRefreshButton: false,
      initialSlide: undefined,
      isRefButtonClicked: false,
      timerObject: {},
    };
    this.selectedOption = null;
  }
  componentDidMount() {
    this.checkForInitialSlideForComingMatch(this.props.data);
    this.isShowTimer(this.props.data);
    this.checkForRefreshButtonAndData(this.props.data);
  }
  componentWillUnmount() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
    if (this.stateCountDownTimer) {
      clearInterval(this.stateCountDownTimer);
    }
  }
  checkForInitialSlideForComingMatch = data => {
    //check for completed match
    // }

    if (data && data.matches && Array.isArray(data.matches)) {
      const { matches } = data;
      let isCalled = false;
      matches.forEach((item, index) => {
        if (
          item &&
          item.event_state === 'U' &&
          item.event_status &&
          item.event_status.toLowerCase() === 'match yet to begin' &&
          !this.state.initialSlide &&
          !isCalled
        ) {
          if (index !== 0) {
            const activeIndex = index - 1;
            isCalled = true;
            this.setState({ initialSlide: activeIndex });
          }
        }
      });
    }
  };
  isShowTimer = data => {
    if (data && data.matches && Array.isArray(data.matches)) {
      const { matches } = data;
      matches.forEach((item, index) => {
        if (
          item &&
          item.event_state === 'L' &&
          item.event_status &&
          item.event_status.toLowerCase() === 'match yet to begin' &&
          !this.state.enableTimer
        ) {
          this.setState({ enableTimer: true, initialSlide: index });
          this.startTimer(item.start_date);
        }
      });
    }
  };
  checkForRunningStatus = data => {
    let isRuningLive = false;
    if (
      data.event_status.toLowerCase() === 'play in progress' ||
      data.event_status.toLowerCase() === 'match ended' ||
      data.event_status.toLowerCase() === 'strategic time-out' ||
      data.event_status.toLowerCase() === 'super over in progress'
    ) {
      isRuningLive = true;
    }
    return isRuningLive;
  };
  checkForRefreshButtonAndData = data => {
    if (
      data &&
      data.autoUpadteTime &&
      data.matches &&
      Array.isArray(data.matches)
    ) {
      const { matches } = data;
      matches.forEach(item => {
        const isRuningLive = this.checkForRunningStatus(item);
        if (
          item &&
          item.event_state === 'L' &&
          !this.refreshTimer &&
          isRuningLive &&
          !this.state.isShowRefreshButton
        ) {
          this.setState({ isShowRefreshButton: true });
          this.refreshTimer = setInterval(() => {
            //If match ended or Abandoned
            if (
              ((item.event_status === 'Match Ended' &&
                item.event_state === 'R') ||
                item.event_status === 'Match Abandoned') &&
              this.refreshTimer &&
              this.state.isShowRefreshButton
            ) {
              this.setState({
                isShowRefreshButton: false,
              });
              clearInterval(this.refreshTimer);
            }
            this.props.refreshData(this.props.apiURL);
            this.refreshButonClick();
          }, parseInt(data.autoUpadteTime, 10));
        }
      });
    }
  };
  stateCountDownTimer;
  startTimer = dateWithTime => {
    // Set the date we're counting down to
    const countDownDate = new Date(dateWithTime).getTime();
    // Update the count down every 1 second
    this.stateCountDownTimer = setInterval(() => {
      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const timerObject = { minutes, seconds };
      this.setState({ timerObject });

      // If the count down is over, clear the interval and hide the timer and show ref button
      if (distance < 0) {
        clearInterval(this.stateCountDownTimer);
        this.setState({ enableTimer: false, isShowRefreshButton: true });
      }
    }, 1000);
  };
  refreshTimer;
  getSlickSliderSeting = initialSlide => {
    const settings = {
      dots: !this.props.removeDots,
      infinite: false,
      speed: 500,
      slidesToShow: this.props.newAS ? 1.65 : this.props.slidesToShow,
      swipeToSlide: true,
      slidesToScroll: 1,
      initialSlide: initialSlide || 0,
      lazyLoad: true,
      arrows: this.props.showArrow,
      responsive: this.props.newAS
        ? slickResponsiveSettingAS
        : slickResponsiveSetting,
    };
    return settings;
  };
  refreshButonClick = () => {
    //toggle the ref button for showing animation
    this.setState({
      isRefButtonClicked: !this.state.isRefButtonClicked,
    });
  };

  render() {
    // eslint-disable-next-line no-script-url
    const noLink = 'javascript:void(0)';
    let settings;
    if (typeof this.state.initialSlide === 'number') {
      settings = this.getSlickSliderSeting(this.state.initialSlide);
    }

    return (
      <>
        <div className={s.scoreCard}>
          {typeof this.state.initialSlide === 'number' && (
            <Slider {...settings}>
              {this.props.data &&
                this.props.data.matches &&
                Array.isArray(this.props.data.matches) &&
                this.props.data.matches.map(matchDetails => (
                  <div
                    className={classNames({
                      [s.cardItem]: true,
                      [s.completed]: matchDetails.event_state === 'R',
                      [s.upcoming]: matchDetails.event_state === 'U',
                      [s.live]: matchDetails.event_state === 'L',
                      [s.match_abandoned]:
                        matchDetails.event_status.toLowerCase() ===
                        'match abandoned',
                      [s.inn_break]:
                        matchDetails.event_status.toLowerCase() ===
                        'innings break',
                      [s.superover]:
                        matchDetails.event_status.toLowerCase() ===
                        'super over in progress',
                      [s.match_end]:
                        matchDetails.event_status.toLowerCase() ===
                        'match ended',
                    })}
                  >
                    {this.state.enableTimer &&
                      matchDetails.event_state === 'L' && (
                        <div className={s.match_start_timer}>
                          {this.state.timerObject &&
                            this.state.timerObject.minutes}:{this.state
                            .timerObject && this.state.timerObject.seconds}
                          <p />
                        </div>
                      )}
                    {this.state.isShowRefreshButton &&
                      matchDetails.event_state === 'L' &&
                      matchDetails.event_status.toLowerCase() !==
                        'innings break' &&
                      matchDetails.event_status.toLowerCase() !==
                        'match abandoned' &&
                      matchDetails.event_status.toLowerCase() !==
                        'super over in progress' &&
                      matchDetails.event_status.toLowerCase() !==
                        'match ended' && (
                        <button
                          className={classNames({
                            [s.btn_reload]: true,
                            [s.clicked]: this.state.isRefButtonClicked,
                          })}
                          onClick={() => {
                            this.props.refreshData(this.props.apiURL);
                            this.refreshButonClick();
                          }}
                        />
                      )}
                    {matchDetails.event_state === 'U' ? (
                      <Link
                        href={matchDetails.scorecard}
                        onClick={event => event.stopPropagation()}
                        className={`${s.aLink}`}
                      >
                        <span className={s.info}>
                          {matchDetails.event_name} ,{' '}
                          {dateFormat(
                            new Date(matchDetails.start_date),
                            'D MMM YY',
                          )}
                        </span>
                        {matchDetails.orderredParticipants &&
                          Array.isArray(matchDetails.orderredParticipants) &&
                          matchDetails.orderredParticipants.map(teamDetails => (
                            <div className={s.team}>
                              <span>{teamDetails.short_name}</span>
                              <div className={s.score_card}>
                                {teamDetails &&
                                  teamDetails.teamLink && (
                                    <Link
                                      href={teamDetails.teamLink}
                                      onClick={event => event.stopPropagation()}
                                      target="_blank"
                                    >
                                      <span
                                        className={`${s.teamName} ${
                                          s[
                                            teamDetails.short_name.toUpperCase()
                                          ]
                                        }`}
                                      />
                                    </Link>
                                  )}
                                {teamDetails &&
                                  !teamDetails.teamLink && (
                                    <span
                                      className={`${s.teamName} ${
                                        s[teamDetails.short_name.toUpperCase()]
                                      }`}
                                    />
                                  )}
                                <div className={s.details}>
                                  {teamDetails.value ? (
                                    <p
                                      className={
                                        teamDetails.highlight &&
                                        teamDetails.highlight.toLowerCase() ===
                                          'true' &&
                                        matchDetails.event_status &&
                                        (matchDetails.event_status.toLowerCase() ===
                                          'live' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'play in progress' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'super over in progress' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'super over')
                                          ? s.highlight
                                          : ''
                                      }
                                    >
                                      {teamDetails.run}
                                      <span>{teamDetails.over}</span>
                                    </p>
                                  ) : (
                                    <p>
                                      <span />
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        {matchDetails.event_status.toLowerCase() ===
                          'super over in progress' &&
                          matchDetails.orderredParticipants &&
                          Array.isArray(matchDetails.orderredParticipants) &&
                          matchDetails.orderredParticipants.map(teamDetails => (
                            <>
                              {teamDetails.highlight &&
                                teamDetails.highlight &&
                                teamDetails.sover &&
                                teamDetails.sover !== '' && (
                                  <span className={s.superovercount}>
                                    {teamDetails.sover}
                                  </span>
                                )}
                            </>
                          ))}
                        {matchDetails.event_state === 'U' ? (
                          <span className={s.result}>
                            {`${dateFormat(
                              new Date(matchDetails.start_date),
                              'H:mm',
                            )} IST`},{matchDetails.venue_name &&
                              matchDetails.venue_name.split(',')[1]}
                          </span>
                        ) : (
                          <span className={s.result}>
                            {matchDetails.event_sub_status_custom}
                          </span>
                        )}
                      </Link>
                    ) : (
                      <Link
                        href={
                          matchDetails.event_state === 'U'
                            ? noLink
                            : matchDetails.scorecard
                        }
                        target="_blank"
                        data-ga={`${this.props.categoryPrefix}${
                          this.props.gaEventCategory
                        }|${this.props.gaEventAction}|click_score`}
                        className={s.aLink}
                      >
                        <span className={s.info}>
                          {matchDetails.event_name} -{' '}
                          {dateFormat(
                            new Date(matchDetails.start_date),
                            'D MMM YY',
                          )}
                        </span>
                        {matchDetails.orderredParticipants &&
                          Array.isArray(matchDetails.orderredParticipants) &&
                          matchDetails.orderredParticipants.map(teamDetails => (
                            <div className={s.team}>
                              <span>{teamDetails.short_name}</span>
                              <div className={s.score_card}>
                                {teamDetails &&
                                  teamDetails.teamLink && (
                                    <Link
                                      href={teamDetails.teamLink}
                                      onClick={event => event.stopPropagation()}
                                      target="_blank"
                                    >
                                      <span
                                        className={`${s.teamName} ${
                                          s[
                                            teamDetails.short_name.toUpperCase()
                                          ]
                                        }`}
                                      />
                                    </Link>
                                  )}
                                {teamDetails &&
                                  !teamDetails.teamLink && (
                                    <span
                                      className={`${s.teamName} ${
                                        s[teamDetails.short_name.toUpperCase()]
                                      }`}
                                    />
                                  )}
                                <div className={s.details}>
                                  {teamDetails.value ? (
                                    <p
                                      className={
                                        teamDetails.highlight &&
                                        teamDetails.highlight.toLowerCase() ===
                                          'true' &&
                                        matchDetails.event_status &&
                                        (matchDetails.event_status.toLowerCase() ===
                                          'live' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'play in progress' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'super over in progress' ||
                                          matchDetails.event_status.toLowerCase() ===
                                            'super over')
                                          ? s.highlight
                                          : ''
                                      }
                                    >
                                      {teamDetails.run}
                                      <span>{teamDetails.over}</span>
                                    </p>
                                  ) : (
                                    <p>
                                      <span />
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        {matchDetails.event_status.toLowerCase() ===
                          'super over in progress' &&
                          matchDetails.orderredParticipants &&
                          Array.isArray(matchDetails.orderredParticipants) &&
                          matchDetails.orderredParticipants.map(teamDetails => (
                            <>
                              {teamDetails.highlight &&
                                teamDetails.highlight &&
                                teamDetails.sover &&
                                teamDetails.sover !== '' && (
                                  <span className={s.superovercount}>
                                    {teamDetails.sover}
                                  </span>
                                )}
                            </>
                          ))}
                        {matchDetails.event_state === 'U' ? (
                          <span className={s.result}>
                            {`${dateFormat(
                              new Date(matchDetails.start_date),
                              'H:mm',
                            )} IST`},{matchDetails.venue_name &&
                              matchDetails.venue_name.split(',')[1]}
                          </span>
                        ) : (
                          <span className={s.result}>
                            {matchDetails.event_sub_status_custom}
                          </span>
                        )}
                      </Link>
                    )}
                  </div>
                ))}
            </Slider>
          )}
        </div>
        {this.props.showScheduleLink &&
          this.props.isWapView && (
            <div className="text-center">
              <Link
                className={s.button1}
                href={this.props.data.viewMore}
                data-ga={`${this.props.categoryPrefix}${
                  this.props.gaEventCategory
                }|${this.props.gaEventAction}|click_fullschedule`}
                target="_blank"
              >
                {' '}
                View Complete Schedule
              </Link>
            </div>
          )}
        {!this.props.isWapView &&
          !this.props.hideFooterData && (
            <div className={s.scr_crd_options}>
              {this.props.data &&
                this.props.data.footerData &&
                Array.isArray(this.props.data.footerData) &&
                this.props.data.footerData.map(footerData => (
                  <Link
                    href={footerData.url}
                    className={s.opt_item}
                    target="_blank"
                    data-ga={`${this.props.categoryPrefix}${
                      this.props.gaEventCategory
                    }|${this.props.gaEventAction}|${footerData.gaLabel}`}
                  >
                    <i className={`${s.icons} ${s[footerData.name]}`} />
                    {footerData.name}
                  </Link>
                ))}
            </div>
          )}
      </>
    );
  }
}

ArticleshowInsertSchedule.propTypes = {
  data: PropTypes.shape({
    viewMoreText: PropTypes.string,
    title: PropTypes.string,
    matches: PropTypes.arrayOf(PropTypes.shape({})),
    viewMore: PropTypes.string,
    footerData: PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string,
      map: PropTypes.func,
    }),
  }),
  slidesToShow: PropTypes.number,
  refreshData: PropTypes.func,
  apiURL: PropTypes.string,
  isWapView: PropTypes.bool,
  showScheduleLink: PropTypes.bool,
  showArrow: PropTypes.bool,
  gaEventCategory: PropTypes.string,
  gaEventAction: PropTypes.string,
  hideFooterData: PropTypes.bool,
  removeDots: PropTypes.bool,
};
ArticleshowInsertSchedule.defaultProps = {
  data: undefined,
  refreshData: undefined,
  apiURL: undefined,
  isWapView: false,
  slidesToShow: 2.3,
  showArrow: true,
  showScheduleLink: true,
  gaEventCategory: '-articleshowv2',
  gaEventAction: 'CW23_Widget',
  hideFooterData: false,
  removeDots: false,
};
export default ArticleshowInsertSchedule;
